import { Icon } from "@/shared/components";
import { cn } from "@/shared/utils";
import * as React from "react";

export interface LoadingIndicatorProps extends React.HTMLAttributes<HTMLDivElement> {
    /**
     * The size of the loading spinner
     * @default "medium"
     */
    readonly size?: "small" | "medium";
    /**
     * The message to display below the spinner
     */
    readonly message?: string;
    /**
     * Whether to take up the full viewport height
     * @default false
     */
    readonly fullHeight?: boolean;
    /**
     * Whether to center the spinner in its container
     * @default true
     */
    readonly centered?: boolean;
}

/**
 * A consistent loading indicator component with spinner and optional message
 */
export function LoadingIndicator({
    size = "medium",
    message,
    fullHeight = false,
    centered = true,
    className,
    ...props
}: LoadingIndicatorProps) {
    const iconSizeMap = { small: "xs" as const, medium: "m" as const };

    // Map sizes to text styles
    const textSizeMap = { small: "text-xs", medium: "text-s" };

    return (
        <div className={cn("flex flex-col", fullHeight && "min-h-[50vh]", centered && "items-center justify-center", className)} {...props}>
            <div className="flex flex-col items-center space-y-4 p-4">
                <Icon name="loader" size={iconSizeMap[size]} className={cn("text-primary animate-spin")} />
                {message && <p className={cn("text-muted-foreground text-center font-medium", textSizeMap[size])}>{message}</p>}
            </div>
        </div>
    );
}
